import { render } from "./createUser.vue?vue&type=template&id=2fadc880&scoped=true"
import script from "./createUser.vue?vue&type=script&lang=js"
export * from "./createUser.vue?vue&type=script&lang=js"

import "./createUser.vue?vue&type=style&index=0&id=2fadc880&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fadc880"]])

export default __exports__